import React, {useState} from 'react';
import {useSwipeable} from 'react-swipeable';
import {Controller} from '~/common/FabricInvitation/EventCreateDesign/components/Onboarding/components/Carousel/Controller/Controller';
import './Carousel.sass';

export const CarouselItem = ({children, width}) => (
  <div className="create_flow__carousel__inner__item" style={{width}}>
    {children}
  </div>
);

export const Carousel = ({children, activeIndexCallback, onClickDone}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    const numberOfItems = React.Children.count(children);

    if (newIndex < 0) {
      // biome-ignore-start lint/style/noParameterAssign: dont assign param
      newIndex = 0;
    } else if (newIndex >= numberOfItems) {
      newIndex = numberOfItems - 1;
      // biome-ignore-end lint/style/noParameterAssign: dont assign param
    }

    activeIndexCallback && activeIndexCallback(newIndex);

    setActiveIndex(newIndex);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1),
  });

  return (
    <div {...handlers} className="create_flow__carousel">
      <div
        className="create_flow__carousel__inner"
        style={{transform: `translateX(-${activeIndex * 100}%)`}}
      >
        {children}
      </div>

      <Controller
        updateIndex={updateIndex}
        activeIndex={activeIndex}
        // biome-ignore lint/correctness/noChildrenProp: don't use children prop
        children={children}
        quantityOfItems={children?.length}
        onClickDone={onClickDone}
      />
    </div>
  );
};
